import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, SelectMenu, toast } from '@livable/saas-react-components';
import { Grid, MenuItem, Paper, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { createAdminAccountSchema, createAdminAccountValues } from 'src/utils/formValidation/Admin/CreateAdminAccount';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { translate } from 'src/utils/translator';
import { USER_ROLES_BY_NAME } from 'src/constants/userSetting';
export const ModalForm = _ref => {
  let handleModalClose = _ref.handleModalClose,
    setIsLoadingExternal = _ref.setIsLoadingExternal,
    externalTrigger = _ref.externalTrigger,
    triggerRefresh = _ref.triggerRefresh;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const formik = useFormik({
    initialValues: createAdminAccountValues,
    validationSchema: createAdminAccountSchema,
    onSubmit: async values => {
      setIsLoading(true);
      setIsLoadingExternal(true);
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const data = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: values.phone ? "".concat(phoneCode).concat(values.phone) : '',
        role: values.role
      };
      try {
        const createAdminAccountResp = await store.admin.createAdminAccountAsync.run(_objectSpread({}, beforeSubmitDataValidation(data)));

        // TODO: add existing account error handling!!!!!
        // Ask for human error resp

        if (createAdminAccountResp !== null && createAdminAccountResp !== void 0 && createAdminAccountResp.isSuccessful) {
          toast('success', {
            title: 'Success',
            body: ['Admin profile created']
          });
        }
      } catch (e) {
        console.log('e', e);
        toast('error', {
          body: [JSON.stringify(e)]
        });
      }
      setIsLoading(false);
      setIsLoadingExternal(false);
      externalTrigger();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh();
      handleModalClose();
    }
  });
  return /*#__PURE__*/React.createElement("form", {
    id: "create-account",
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.admin.createAdminAccountAsync.inProgress
  }), /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, t('admin_page.admin_details')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: formik.values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(t(formik.errors.firstName, {
      field: t('general.first_name')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.last_name'),
    variant: "outlined",
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    value: formik.values.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(t(formik.errors.lastName, {
      field: t('general.last_name')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "email",
    name: "email",
    variant: "outlined",
    label: t('general.email_address'),
    value: formik.values.email,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    error: formik.touched.email && Boolean(formik.errors.email),
    helperText: formik.touched.email && translate(t(formik.errors.email, {
      field: t('general.email_address')
    }), t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: formik.handleChange,
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(t(formik.errors.phone, {
      field: t('general.phone_number')
    }), t)
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "role",
    name: "role",
    value: formik.values.role,
    label: t('general.please_select'),
    labelId: "software-selector-label",
    onChange: formik.handleChange,
    error: formik.touched.role && Boolean(formik.errors.role),
    helperText: formik.touched.role
  }, Object.entries(USER_ROLES_BY_NAME).filter(_ref2 => {
    let _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[1];
    return store.account.userProfile.isUserAdmin ? value === USER_ROLES_BY_NAME.LivableAdmin : value === USER_ROLES_BY_NAME.LivableAdmin || value === USER_ROLES_BY_NAME.LivableSuperAdmin;
  }).map(_ref4 => {
    let _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: value,
      key: key
    }, value);
  }))))));
};